import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import HeroBanner from '../components/HeroBanner';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { FaBars } from 'react-icons/fa';
import { MdChatBubbleOutline } from 'react-icons/md';
import { IoIosSearch } from 'react-icons/io';
import { FaCalendarAlt, FaUser, FaRegCommentDots } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';


const Blog: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement('script');
    script.src = '/js/main.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div className="goto-here">
      {/* Top Bar */}
      <div className="py-1 bg-primary">
        <div className="container">
          <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
            <div className="col-lg-12 d-block">
              <div className="row d-flex">
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiPhone size={12} color="white" /></div>
                  <span className="text">+91 9148761750</span>
                </div>
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiSend size={12} color="white" /></div>
                  <span className="text">care@fhome.shop</span>
                </div>
                <div className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right">
                  <span className="text">3-5 Business days delivery &amp; Free Returns</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%" ,width: "80px"}}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                </div>
              </li>
              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              <li className="nav-item active"><a href="/blog" className="nav-link">Blog</a></li>
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>
              <li className="nav-item cta cta-colored"> <a href="/cart" className="nav-link">
                <span><MdShoppingCart size={18} /></span> [0]
              </a></li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <HeroBanner image="images/fhome-ingredients-platter.jpg">
        <div className="row no-gutters slider-text align-items-center justify-content-center">
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs"><span className="mr-2"><a href="/">Home</a></span> <span>Blog</span></p>
            <h1 className="mb-0 bread">Blog</h1>
          </div>
        </div>
      </HeroBanner>
      {/* Blog Section */}
      <section className="ftco-section ftco-degree-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 ftco-animate">
              <div className="row">
                {/* Blog Entries */}
                {[1, 2, 3, 4, 5, 6].map(i => (
                  <div className="col-md-12 d-flex ftco-animate" key={i}>
                    <div className="blog-entry align-self-stretch d-md-flex">
                      <a href="/blog-single" className="block-20" style={{ backgroundImage: `url('images/image_${i}.jpg')` }}></a>
                      <div className="text d-block pl-md-4">
                        <div className="meta mb-3">
                          <div><a href="#">July 20, 2019</a></div>
                          <div><a href="#">Admin</a></div>
                          <div> <a href="#" className="meta-chat d-flex align-items-center">
                            <MdChatBubbleOutline style={{ marginRight: '5px' }} /> 3
                          </a></div>
                        </div>
                        <h3 className="heading"><a href="#">F.home - Fresh From Home</a></h3>
                        <p>F.home - Fresh From Home brings pure, authentic, naturally produced food from farms and local farm communities to every home.</p>
                        <p><a href="/blog-single" className="btn btn-primary py-2 px-3">Read more</a></p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Sidebar */}
            <div className="col-lg-4 sidebar ftco-animate">
              <div className="sidebar-box">
                <form action="#" className="search-form">
                  <div className="form-group position-relative">
                    <span className="search-icon">
                      <IoIosSearch size={18} color="#888" />
                    </span>
                    <input type="text" className="form-control search-input" placeholder="Search..." />
                  </div>
                </form>
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Categories</h3>
                <ul className="categories">
                  <li><a href="#">Ghee <span>(12)</span></a></li>
                  <li><a href="#">Honey <span>(22)</span></a></li>
                  <li><a href="#">Dry Fruits <span>(37)</span></a></li>
                  <li><a href="#">Oils <span>(42)</span></a></li>
                </ul>
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Recent Blog</h3>
                {[1, 2, 3].map(i => (
                  <div className="block-21 mb-4 d-flex" key={i}>
                    <a className="blog-img mr-4" style={{ backgroundImage: `url('images/image_${i}.jpg')` }}></a>
                    <div className="text">
                      <h3 className="heading-1"><a href="#">F.home - Fresh From Home</a></h3>
                      <div className="meta d-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                        <div className="mr-3 d-flex align-items-center">
                          <FaCalendarAlt style={{ marginRight: '5px' }} />
                          April 09, 2019
                        </div>
                        <div className="mr-3 d-flex align-items-center">
                          <FaUser style={{ marginRight: '5px' }} />
                          Admin
                        </div>
                        <div className="d-flex align-items-center">
                          <FaRegCommentDots style={{ marginRight: '5px' }} />
                          19
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Tag Cloud</h3>
                <div className="tagcloud">
                  {['ghee', 'honey', 'cashews', 'groundnut-oil', 'jaggery', 'coconut', 'sesame-oil', 'dry-fruits'].map(tag => (
                    <a href="#" className="tag-cloud-link" key={tag}>{tag}</a>
                  ))}
                </div>
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Paragraph</h3>
                <p>F.home - Fresh From Home brings pure, authentic, naturally produced food from farms and local farm communities to every home.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      <a
        href="https://wa.me/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>
    </div>
  );
};

export default Blog;

